export default __webpack_public_path__ + "static/media/massUpload.4f2a8851.svg";